import React from "react";
import baseStyle from "../../../style.module.css";
import { TEMPLATE_KEYS } from "ui/pages/TemplatePreview/constants";
import { Textarea } from "@my-scoot/component-library-legacy";
import { handleErrors } from "../../common/validator";

const formData = {
  subtitle: {
    key: "subtitle",
    placeholder: "Success Stories from My Amazing Tribe",
  },
  description: {
    key: "description",
    placeholder:
      "The ultimate planning solution for dedicated professionals who want to reach their personal goals",
  },
};

export const TextFields = ({
  slug_value,
  Testimonials_config,
  errorObject,
  setErrorObject,
  setField,
  props,
}) => {
  const handleSubtitleChange = (e) => {
    const value = e.target.value;
    const maxSubtitleLength =
      Testimonials_config?.maxSubtitleLength[props?.state?.template?.slug];

    const error = handleErrors(
      errorObject,
      formData.subtitle.key,
      value,
      maxSubtitleLength,
      false
    );
    setErrorObject(error);

    setField("social_info", {
      ...props?.state?.social_info,
      testimonials_subtitle: value || "",
    });
  };

  const handleDescChange = (e) => {
    const value = e.target.value;
    const maxDescLength =
      Testimonials_config?.maxDescLength[props?.state?.template?.slug];

    const error = handleErrors(
      errorObject,
      formData.description.key,
      value,
      maxDescLength,
      false
    );
    setErrorObject(error);

    setField("social_info", {
      ...props?.state?.social_info,
      testimonials_description: value || "",
    });
  };

  return slug_value === TEMPLATE_KEYS.UNLOCK ? (
    <div>
      <div className={baseStyle.label}>Subtitle</div>
      <div className={baseStyle.field}>
        <Textarea
          error={errorObject?.subtitle}
          helperText={errorObject?.subtitle}
          placeholder={formData.subtitle.placeholder}
          value={props?.state?.social_info?.testimonials_subtitle || ""}
          rows="2"
          customClasses={{
            wrapper: baseStyle.placeholder,
          }}
          maxLength={
            Testimonials_config?.maxSubtitleLength[props?.state?.template?.slug]
          }
          onChange={(e) => handleSubtitleChange(e)}
          minWidth="100%"
        />
      </div>
      <div className={baseStyle.label}>Description</div>
      <div className={baseStyle.field}>
        <Textarea
          error={errorObject?.description}
          helperText={errorObject?.description}
          placeholder={formData.description.placeholder}
          value={props?.state?.social_info?.testimonials_description || ""}
          rows="4"
          customClasses={{
            wrapper: baseStyle.placeholder,
          }}
          maxLength={
            Testimonials_config?.maxDescLength[props?.state?.template?.slug]
          }
          onChange={(e) => handleDescChange(e)}
          minWidth="100%"
        />
      </div>
    </div>
  ) : null;
};
